export default __webpack_public_path__ + "static/media/applications-image-06.114f155e.jpg";